export const REFERENCE_OPTIONS = [
  { title: "Antes da data", id: "before" },
  { title: "Depois da data", id: "after" },
  { title: "No mesmo dia", id: "sameDay" },
];

export const OPERATOR_OPTIONS = [
  { title: "Igual", id: "==" },
  { title: "Diferente", id: "!=" },
  { title: "Nulo", id: "is null" },
  { title: "Não Nulo", id: "is not null" }
];